import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './umami';
import { installChunkErrorHandler } from './utils/chunkErrorHandler';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';

// In an SPA, the browser's native scroll restoration fires before React
// has rendered the new page — scrolling stale DOM content. We handle
// restoration ourselves (ScrollToTop + per-page logic), so disable native.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Auto-recover from chunk load failures (stale index.html after deployment).
// Detects ChunkLoadError / dynamic-import failures and reloads the page to
// fetch a fresh index.html with correct chunk hashes, instead of showing
// the ErrorBoundary "Something went wrong" page.
installChunkErrorHandler();

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode double-invokes effects/renders in development to catch bugs.
// In production it adds overhead with no benefit, so we only enable it in dev.
const appTree = (
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

root.render(
  process.env.NODE_ENV === 'development'
    ? <React.StrictMode>{appTree}</React.StrictMode>
    : appTree
);
